// extracted by mini-css-extract-plugin
export var typingIndicator = "_o5-0";